import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { Button } from '$components'
import { LogoIcon, SidebarLeftIcon, XIcon } from '$components'
import { Fragment, ReactNode, useState, useEffect } from 'react'
import { useModalRegistry } from '../../contexts/modal-registry'

export type MobileMenuProps = {
  children: (close: () => void) => ReactNode
}

export function MobileMenu({ children }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const { openModal, closeModal } = useModalRegistry()

  const handleClose = () => setIsOpen(false)

  useEffect(() => {
    if (isOpen) {
      openModal()
      return () => closeModal()
    }
  }, [isOpen, openModal, closeModal])

  return (
    <Fragment>
      <Button
        variant="secondary"
        onClick={() => setIsOpen(true)}
        className="!p-2 hover:bg-gray-100 rounded-xl transition-colors"
      >
        <SidebarLeftIcon className="size-4" />
      </Button>

      <Transition
        show={isOpen}
        as={Fragment}
      >
        <Dialog
          onClose={handleClose}
          className="relative z-50"
        >
          {/* Backdrop */}
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-black/25"
              aria-hidden="true"
            />
          </TransitionChild>

          {/* Panel */}
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-100"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <DialogPanel className="fixed top-0 left-0 w-80 h-full bg-white border-r border-gray-200 p-4 transform transition-transform">
              <div className="flex items-center justify-between pb-4 w-full">
                <LogoIcon className="h-[22px] w-20" />

                <Button
                  variant="ghost"
                  onClick={handleClose}
                  className="!p-2 hover:bg-gray-100 rounded-lg transition-colors mb-2"
                >
                  <XIcon className="size-4" />
                </Button>
              </div>

              {children(handleClose)}
            </DialogPanel>
          </TransitionChild>
        </Dialog>
      </Transition>
    </Fragment>
  )
}
